import axios from '@/core/http'
import { saveAs } from 'file-saver'

const getUsersActionsExcelReport = (
  dateStart: Date,
  dateEnd: Date,
  user: number | undefined = undefined,
) => {
  return axios
    .get('reports/users-actions/', {
      responseType: 'blob',
      params: {
        'date_start': dateStart,
        'date_end': dateEnd,
        'user': user,
      },
    })
    .then(response => {
      saveAs(new Blob([response.data]), 'Отчет.xlsx')
    })
}

export { getUsersActionsExcelReport }
